/**
 * Reset Chat Button Component
 * Clears the current chat session and starts a new one
 * Used as both "New Chat" (in history sidebar) and "Clear Chat" (in main header)
 */

import { IconDefinition } from '@fortawesome/pro-regular-svg-icons';
import { Icon } from '@hl/ui-components';
import React from 'react';

import { useSessionManagerContext } from '../../sessionManagement/SessionManagerContext';
import { ResetButton } from './ResetChatButton.styled';

export interface ResetChatButtonProps {
  icon: IconDefinition;
  text: string;
  className?: string;
}

const ResetChatButton: React.FC<ResetChatButtonProps> = ({
  icon,
  text,
  className = '',
}) => {
  const sessionManager = useSessionManagerContext();

  const resetChat = (e: React.MouseEvent<HTMLButtonElement>) => {
    sessionManager.resetSession();

    // Remove focus from button
    (e.currentTarget as HTMLButtonElement).blur();

    // Focus the message input after a short delay to ensure DOM is updated
    setTimeout(() => {
      const messageInputBox = document.querySelector('.message-input-box');
      const textarea = messageInputBox?.querySelector('textarea') as HTMLTextAreaElement;
      if (textarea) {
        textarea.focus();
      }
    }, 100);
  };

  return (
    <ResetButton type="button" className={className} onClick={resetChat}>
      <Icon icon={icon} />
      <span className="ai-button-text">{text}</span>
    </ResetButton>
  );
};

export default ResetChatButton;

